import React from 'react';

import ChangePasswordForm from '@components/FW/Forms/Auth/ChangePasswordForm';

import { AuthPanelWrap } from './Auth.styled';

const ChangePassword: React.FC = () => {
	return (
		<AuthPanelWrap>
			<ChangePasswordForm />
		</AuthPanelWrap>
	);
};

export default ChangePassword;
